import { AuthenticationService } from "../authenticationService";
import { APIService } from "../apiService";
import { EuRelabelCheckIn } from "src/types";
import { PostEuRelabelCheckInRequestBody } from "src/types/api/euRelabelCheckIns/postEuRelabelCheckIn";
import { PatchEuRelabelCheckInProductQuantityRequestBody } from "src/types/api/euRelabelCheckIns/patchEuRelabelCheckInProductQuantity";
import { PostTransferOrderEuRelabelCheckInRequestBody } from "src/types/api/euRelabelCheckIns/postTransferOrderEuRelabelCheckIn";

class EuRelabelCheckInAPIService extends APIService {
  constructor(authenticationService: AuthenticationService) {
    super(authenticationService, "/v1/eu-relabel-check-ins");
  }

  async postEuRelabelCheckIn(requestBody: PostEuRelabelCheckInRequestBody): Promise<EuRelabelCheckIn> {
    return await this.jwtRequest("POST", "", requestBody);
  }

  async getAllEuRelabelCheckInsByPurchaseOrderId(purchaseOrderId: string): Promise<EuRelabelCheckIn[]> {
    return await this.jwtRequest("GET", "", undefined, { purchaseOrderId });
  }

  async patchEuRelabelCheckInProductQuantity(
    body: PatchEuRelabelCheckInProductQuantityRequestBody
  ): Promise<EuRelabelCheckIn[]> {
    return await this.jwtRequest("PATCH", "/product-quantity", body);
  }

  async postTransferOrderEuRelabelCheckIn(
    requestBody: PostTransferOrderEuRelabelCheckInRequestBody
  ): Promise<EuRelabelCheckIn> {
    return await this.jwtRequest("POST", "/transfer-order", requestBody);
  }

  async getAllEuRelabelCheckInsByTransferOrderId(transferOrderId: string): Promise<EuRelabelCheckIn[]> {
    return await this.jwtRequest("GET", "/by-transfer-order", undefined, { transferOrderId });
  }
}

export { EuRelabelCheckInAPIService };
